module.exports = __webpack_public_path__ + "static/img/brand-08.74c9503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-08.png
// module id = Jtx7
// module chunks = 0